<script setup lang="ts">
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/Kafelki'
const component_default_values: CmsCustomComponentType = {
  background: { value: undefined, selectValues: ['white', 'bg-background-1'], default_value: 'bg-white', settingType: 'select', setting_label: 'zmien tło' },
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-10 xl:py-20 flex flex-col gap-15"
      :class="component_values?.background?.value ?? component_values?.background?.default_value"
    >
      <!-- <div class="flex flex-col gap-7.5">
      <span class="text-H2 text-Tekst">
        <CmsText
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
        />
      </span>
      <span class="text-H4 text-Tekst">
        <CmsText
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
        />
      </span>
    </div> -->
      <CmsCustomComponentList
        v-slot="{ component_values: ComponentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 grid grid-cols-1 2xl:grid-cols-4 grid-rows-1 gap-5"
      >
        <div
          v-for="(item, index) in ComponentListValues"
          :key="JSON.stringify(item)"
          class="rounded-3xl px-5 py-10 flex flex-col items-center gap-5"
          :class="index % 2 == 0 ? 'bg-Secondary' : 'bg-background-2'"
        >
          <CmsImage
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'img']"
            class="w-24 h-18"
          />
          <span
            class="text-H4 text-center"
            :class="index % 2 == 0 ? 'text-white' : 'text-Tekst'"
          >
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'tekst_1']"
            />
          </span>
          <span
            class="text-Paragraph text-center"
            :class="index % 2 == 0 ? 'text-white' : 'text-Tekst'"
          >
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'tekst_2']"
            />
          </span>
        </div>
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
